import { render, staticRenderFns } from "./FreeVacation.vue?vue&type=template&id=0c08618c"
import script from "./FreeVacation.vue?vue&type=script&lang=js"
export * from "./FreeVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports